<template>
  <div class="staff-management">
    <!-- Header Section -->
    <div class="header-section">
      <div class="header-content">
        <div class="header-top-row">
          <!-- Title Section -->
          <div class="title-section">
            <h1 class="main-title">Staff Management</h1>
            <p class="subtitle">
              Manage staff accounts, roles, and permissions across the platform
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- Staff Management Component -->
    <div class="staff-content">
      <v-card class="elevation-4" style="border-radius: 12px; overflow: hidden">
        <userTable />
      </v-card>
    </div>
  </div>
</template>

<script>
import userTable from "@/components/back-office/UserManagement/UserTable.vue";
import { mapState } from "vuex";

export default {
  components: {
    userTable,
  },

  computed: {
    ...mapState({
      recentPath: (state) => state.backOffice.recentRoutePath,
    }),
  },

  destroyed() {
    this.$store.commit("fetchUserBack/resetState");
  },

  mounted() {
    this.initializePage();
  },

  methods: {
    initializePage() {
      const path = [
        {
          text: "Select province",
          disabled: false,
          href: "/weserve_admin_login/select/",
        },
        {
          text: "Staff management",
          disabled: true,
          href: "/weserve_admin_login/control/-/usermanage",
        },
      ];
      this.$store.commit("backOffice/saveRecentRoute", path);
    },
  },
};
</script>

<style scoped>
.staff-management {
  min-height: 100vh;
  background: transparent;
  padding: 20px;
}

.header-section {
  padding: 2rem 1rem;
  margin-bottom: 1rem;
}

.header-content {
  max-width: 1200px;
  margin: 0 auto;
}

.header-top-row {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 2rem;
}

.title-section {
  flex: 1;
  text-align: left;
}

.main-title {
  font-size: 3rem;
  font-weight: 700;
  color: #2c3e50;
  margin-bottom: 0.5rem;
  text-align: left;
  text-shadow: 2px 2px 4px rgba(117, 117, 117, 0.5);
}

.subtitle {
  font-size: 1.2rem;
  color: #7f8c8d;
  text-align: left;
  margin-bottom: 0;
}

.staff-content {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 1rem 2rem;
}

@media (max-width: 768px) {
  .staff-management {
    padding: 10px;
  }

  .header-top-row {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }

  .title-section {
    text-align: center;
    margin-bottom: 1rem;
  }

  .main-title {
    font-size: 2rem;
    text-align: center;
  }

  .subtitle {
    text-align: center;
  }
}
</style>